import { Sparkles } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

interface NewBadgeProps {
  className?: string;
}

const NewBadge = ({ className }: NewBadgeProps) => {
  return (
    <Badge 
      className={`bg-gradient-to-r from-green-500 to-emerald-500 text-white text-[10px] px-1.5 py-0.5 border-0 ${className}`}
    >
      NEW
    </Badge>
  );
};

export default NewBadge;
